import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useUser } from '../../contexts/UserContext';
import { LoadingSpinner } from '../common/LoadingSpinner';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, signOut } = useAuth();
  const { userData, loading: userLoading } = useUser();
  const [waitedForUser, setWaitedForUser] = useState(false);

  // Give UserContext a grace period to load after auth resolves
  useEffect(() => {
    if (!loading && !userLoading && isAuthenticated && !userData) {
      const timer = setTimeout(() => setWaitedForUser(true), 3000);
      return () => clearTimeout(timer);
    }
    if (userData) {
      setWaitedForUser(false);
    }
  }, [loading, userLoading, isAuthenticated, userData]);

  if (loading || userLoading) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but no user document after grace period, sign out
  if (!userData && waitedForUser) {
    signOut();
    return <Navigate to="/login" replace />;
  }

  // Still waiting for user doc — show spinner
  if (!userData) {
    return <LoadingSpinner message="Loading your profile..." />;
  }

  // For admin-only routes (will add admin check later in Phase 6)
  if (adminOnly) {
    // TODO: Check if user has admin role
    // For now, allow all authenticated users
  }

  return children;
};
